import {
  ConvertibleUnit,
  format,
  FormatOptions,
  Unit,
} from '@dynatrace-sdk/units';

import { Formatter, isFormatterOptions } from '../types/formatter.js';
import { defaultUnitFormatter } from './defaultUnitFormatter.js';

export function getFormatter(
  formatter?: Formatter | FormatOptions<Unit, ConvertibleUnit>,
): Formatter {
  if (!formatter) {
    return (value: number, unit?: string | Unit) =>
      defaultUnitFormatter(unit)(value);
  }

  if (isFormatterOptions(formatter)) {
    return (value: number) => format(value, formatter);
  }

  return formatter;
}
